export default "__VITE_ASSET__HpITkvlo__"